import { respondTo } from 'assets/styled/breakpoints';
import { Field } from 'formik';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30rem;
  width: 100%;
  max-width: 100%;

  ${respondTo.bigPhone`
     padding: 15rem;
   `}
`;

export const FormikContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5rem;
  width: 100%;
  max-width: 100%;
`;

export const Row = styled.div`
  margin-top: 20rem;
  display: flex;
  gap: 30rem;
  width: 100%;
  max-width: 100%;

  ${respondTo.horizontalTablet`
    flex-wrap: wrap;
  `}

  ${respondTo.smallTablet`
    flex-direction: column;
    gap: 20rem;
  `}
`;

export const StyledSelect = styled(Field)`
  width: 100%;
`;

export const SelectWrapper = styled.div`
  width: 100%;
  max-width: 100%;

  ${respondTo.horizontalTablet`
    width: 30%;
  `}

  ${respondTo.smallTablet`
    width: 100%;
  `}
`;
